import {
    NinchatActionType,
    NinchatSendFileUnlinkedAction,
} from '../types/actions'

import {
    NinchatActionParams,
} from '../NinchatClient'
import {UserID} from 'api/types/properties'


import {createAsyncThunk} from '@reduxjs/toolkit'
import {sendFile} from 'state/ui'

const actionTypePrefix = 'NINCHAT/action'

export const sendUnlinkedFiles = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatSendFileUnlinkedAction}`,
    async (arg: NinchatActionParams<NinchatSendFileUnlinkedAction> & {file: File}, {
        dispatch, rejectWithValue,
    }) => {
        const {
            file, ...params
        } = arg

        params.action = NinchatActionType.NinchatSendFileUnlinkedAction

        try {
            // Dispatch sendFile action
            return await dispatch(sendFile({
                actionType: NinchatActionType.NinchatSendFileUnlinkedAction,
                chat: {user_id: params.user_id} as {user_id: UserID},
                files: [file],
            }))
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
